<template>
    <div>
        <div >
            <p>Below is your updated Address information. Please click 'Submit' to update your address on your RI DMV Customer record. To make change click on 'Previous'.</p>
            <p>You will receive a address change confirmation at the email on file with the DMV.</p>
            <p>
                <strong>Please note:</strong> You do not need a updated driver's license or registration certificate as a result of this address change. Visit your local RI DMV branch if you wish to obtain a new one with your updated address.
            </p>
            <div class="app-confirm-address">
                <div>
                    <h2>
                        Physical Address
                    </h2>
                    <Address :addressDetails = "userPhysicalAddress"/>
                </div>
                <div>
                    <h2>
                        Mailing Address
                    </h2>
                    <Address :addressDetails = "userMailingAddress"/>
                </div>
            </div>
            <div class="voter-reg">
                <input type="checkbox" id="voterRegistration" v-model="updateVoterRegAddress">
                <label for="voterRegistration">
                    If you are registered to vote in RI, we will use your Physical address to update where you are registered to vote. 
                    If you do not wish to update your voter registration address, please check this box.
                </label>
            </div>
        </div>
      <BaseButtonGroup>
        <button type="button" @click="handleRouting('previous')">Previous</button>
            <!-- <button type="submit" class="app-btn-primary" @click.prevent="handleRouting('next')">
                Submit
            </button> -->
        <CustomButton @click="handleRouting('next')">
            Submit
        </CustomButton>
      </BaseButtonGroup>
    </div>
</template>


<script>
import * as COMMONS from '../../store/_commons';
import { mapGetters, mapActions } from 'vuex';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import Address from './Address.vue';
import CustomButton from '../CustomButton.vue';

export default {
    name: 'ConfirmAddress',
    components: {
        BaseButtonGroup,
        Address,
        CustomButton
    },
    data() {
        return {
            updateVoterRegAddress: false,
        }
    },
    computed: {
        ...mapGetters({
            personalInfo: COMMONS.GUEST_PERSONAL_INFO,
            addressLookupInfo: COMMONS.GUEST_ADDRESS_LOOKUP_INFO 
        }),
        userAddress() {
            return this.$store.state.guestLogin.userAddress
        },
        usStates() {
            return this.addressLookupInfo.allUsStates;
        },
        instateZipCodes() {
            return this.addressLookupInfo.allInstateZipcodes;
        },
        userPhysicalAddress() {
            if(this.$store.state.guestLogin.physicalAddressType == 'standardPhysicalAddress') {
                return this.$store.state.guestLogin.standardPhysicalAddress
            }
            else {
                return this.$store.state.guestLogin.userPhysicalAddress;
            }
        },
        userMailingAddress() {
            if(this.$store.state.guestLogin.mailingAddressType == 'standardMailingAddress') {
                return this.$store.state.guestLogin.standardMailingAddress
            }
            else {
                return this.$store.state.guestLogin.userMailingAddress;
            } 
        },
        physicalStateCode() {
            return this.usStates.filter((value) => {
                return value.stateId == this.userPhysicalAddress.stateId;
            })
        },
        mailingStateCode() {
            return this.usStates.filter((value) => {
                return value.stateId == this.userMailingAddress.stateId;
            })
        },
    },
    created() {

    },
    mounted() {
        window.scroll(0,0);
        document.body.setAttribute("tabindex", "1");
        document.body.focus();

        document.body.removeAttribute("tabindex");
        document.getElementById("app").scrollTop = 0;
    },
    methods: {
        ...mapActions({
            getUpdateAddress: COMMONS.GUEST_UPDATE_ADDRESS,
            postConfirmAddress: COMMONS.GUEST_CONFIRM_ADDRESS
        }),
        async handleRouting(info) {
            if(info=='previous') {
                if(this.$store.state.guestLogin.skipStepTo) {
                    this.$store.state.guestLogin.addressUpdateStep = 1;
                }
                else {
                    this.$store.state.guestLogin.addressUpdateStep = 2;
                }
            }
            else if (info=='next') {
                let payloadData =     {
                    doNotUpdateVoterRegistrationAddress: this.updateVoterRegAddress,
                    isSameAddressForMailing: this.$store.state.guestLogin.physicalMailingAddressCheck,
                    mailingAddress: {
                        addressLine1: this.userMailingAddress.addressLine1,
                        addressLine2: this.userMailingAddress.addressLine2,
                        addressType: this.personalInfo.personalInformation.mailingAddress.addressType,
                        city: this.userMailingAddress.city,
                        country: this.personalInfo.personalInformation.mailingAddress.country,
                        internationalZipCode: this.personalInfo.personalInformation.mailingAddress.internationalZipCode,
                        province: this.personalInfo.personalInformation.mailingAddress.province,
                        // state: this.mailingStateCode[0].code,
                        state: this.userMailingAddress.stateId.toString(),
                        zipCode: this.userMailingAddress.zipCode,
                        zipPlus: this.userMailingAddress.zipPlus
                    },
                    physicalAddress:  {
                        addressLine1: this.userPhysicalAddress.addressLine1,
                        addressLine2: this.userPhysicalAddress.addressLine2,
                        addressType: this.personalInfo.personalInformation.physicalAddress.addressType,
                        city: this.userPhysicalAddress.city,
                        country: this.personalInfo.personalInformation.physicalAddress.country,
                        internationalZipCode: this.personalInfo.personalInformation.physicalAddress.internationalZipCode,
                        province: this.personalInfo.personalInformation.physicalAddress.province,
                        // state: this.physicalStateCode[0].code,
                        state: this.userPhysicalAddress.stateId.toString(),
                        zipCode: this.userPhysicalAddress.zipCode,
                        zipPlus: this.userPhysicalAddress.zipPlus
                    }
                }
               await this.postConfirmAddress(payloadData);
            }          
        },
        checkMailingAddress() {
            if(this.physicalMailingAddressCheck) {
                this.mailingAddress1 = this.physicalAddress1;
                this.mailingAddress2 = this.physicalAddress2;
                this.mailingAddressCity = this.physicalAddressCity;
                this.mailingAddressState = this.physicalAddressState;
                this.mailingAddressZip = this.physicalAddressZip;
            }
        }
    }
}
</script>

<style scoped lang="scss">
.app-address-info{
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 1rem;
  .app-input-address{
    display: block;
    .app-user-address-info{
      display: flex;
      gap: 2rem;
    }
    .app-user-address{
      margin-bottom: 1rem;
      display: flex;
      .user-address-info{
        min-width: 275px;
      }
      .diff{
        padding: 0.5rem;
      }
      .zip-selection {
        width: 106px !important;
      }
      .user-address-info-zipplus {
        max-width: 100px;
      }
      .user-address-info-gray{
        background: lightgray;
      }
    }
  }
}

.app-confirm-address{
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    margin-top: 1rem;

    h2 {
        font-size: 1rem;
        font-family: "Work Sans", sans-serif;
    }
}

.voter-reg {
    label {
        display: block;
        margin-left: 1rem;
    }
    input {
        float: left;
        height: 20px;  
    }
}

@media only screen and (max-width: 510px) {
  .app-address-info{
    .app-input-address{
      display: block;
      .app-user-address-info{
        display: block;
      }
      .app-user-address{
        .user-address-info{
          min-width: 300px;
        }
        .user-address-info-city {
          width: 200px;
        }
        .zip-selection {
          width: 106px !important;
        }
        .user-address-info-zipplus {
          max-width: 100px;
        }
      }
    }
  }
}
</style>